// AG Grid v33+ module registration — MUST run before any grid renders.
import 'src/bootstrap/ag-grid-modules';
import { LocalizationContextBuilder } from '@amzn/arb-tools';
import { MbmProvider } from '@amzn/react-arb-tools';
import React, { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { DEFAULT_LOCALE_EN_US, TRANSLATION_ROUTE } from 'src/constants/AppConstants';
import arbManifest from '../i18n/translations/arbManifest';
import { AppRouter } from './AppRouter';
import { AppContextProvider } from './context/AppContextProvider';
import { EmbeddedAppExternalLinkProvider } from './context/EmbeddedAppExternalLinkContext';
import { AuthContextProvider } from './context/AuthContextProvider';
import { EventsApiContextProvider } from './context/EventsApiContextProvider';
import { ErrorFallback } from './generic-components/ErrorFallback';
import { getDocumentTitle } from 'src/utilities/DocumentTitleUtils';

const savedLocale = (typeof window !== 'undefined' && localStorage.getItem('finsuite-locale')) || DEFAULT_LOCALE_EN_US;
const localizationContext = new LocalizationContextBuilder().withLocale(savedLocale).withDefaultLocale(DEFAULT_LOCALE_EN_US).build();

const mbmOptions = {
  arbManifest,
  defaultLocalizationContext: localizationContext,
  urlPrefix: TRANSLATION_ROUTE
};

export const App: React.FC = () => {
  useEffect(() => {
    document.title = getDocumentTitle();
  }, []);

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        window.location.reload();
      }}
    >
      <MbmProvider {...mbmOptions}>
        <AuthContextProvider>
          <AppContextProvider>
            <EventsApiContextProvider>
              <EmbeddedAppExternalLinkProvider>
                <AppRouter />
              </EmbeddedAppExternalLinkProvider>
            </EventsApiContextProvider>
          </AppContextProvider>
        </AuthContextProvider>
      </MbmProvider>
    </ErrorBoundary>
  );
};
